import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import {
    AdjustmentContianer,
    AdjustmentSummary,
    AdjustmentSummaryDataContiner,
    AdjustmentSummaryFont,
    DesktopInvoiceButtonContainer,
    MobileInvoiceButtonConainer,
    AdjustmentContentWrapper,
} from 'src/pages/orders/components/orderDetails/billingSummary/adjustments/Adjustments.styled';
import { UsagePriceFont } from 'src/pages/orders/components/orderDetails/billingSummary/usagePricing/UsagePricing.styled';
import { RequestInvoiceContainer } from 'src/pages/orders/components/orderDetails/billingSummary/BillingSummary.styled';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
//import BasicCard from 'src/common/components/card/basicCard/BasicCard';
import Card from 'src/common/refactoredComponents/card/Card';
import {
    showHideSummaryModal,
    showHideRequestInvoice,
} from 'src/pages/orders/redux/actions';
import AdjustmentContainer from 'src/pages/orders/components/orderDetails/billingSummary/adjustments/AdjustmentContainer';
import { priceFormatObj } from 'src/pages/consignmentBilling/utils/eventHandlerUtil';
import { setCurrencyFormat } from 'src/utils/util';
import { useTranslation } from 'react-i18next';

const Adjustments = ({
    adjustments,
    toggleCard,
    handleSetItemClick,
    ordersList,
    isRequestInvoice,
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const adjustmentsDetails = useSelector(
        (state) => state.orderSummaryReducer.billingSummary?.adjustments
    );
    const myCaseRef = useSelector(
        (state) => state.orderSummaryReducer.myCaseRef
    );

    const adjustmentSummary = useSelector(
        (state) => state.orderSummaryReducer.billingSummary?.cartSummary
    );

    const currencyISOCode = useSelector(
        (state) =>
            state.orderSummaryReducer.billingSummary?.cartSummary
                ?.currencyISOCode
    );

    const requestInvoiceHandler = () => {
        if (!isRequestInvoice) {
            return;
        }
        dispatch(
            showHideRequestInvoice({
                requestInvoiceState: true,
                myCaseRefId: myCaseRef,
                isRequestInvoiceOrderListPage: false,
                isRequestInvoiceSearchListPage: false,
            })
        );
        dispatch(
            showHideSummaryModal({
                orderSummaryModal: false,
            })
        );
    };

    const adjustmentTitle = adjustmentSummary?.adjustmentTotal
        ? `Adjustments (${setCurrencyFormat(
              adjustmentSummary.adjustmentTotal,
              true,
              { currency: currencyISOCode }
          )})`
        : `Adjustments (${setCurrencyFormat(0, true, {
              currency: currencyISOCode,
          })})`;

    return (
        <>
            <CollapsableCard
                id="orders-adjustments-billingSummary-adjustments"
                title={adjustmentTitle}
                onClick={() => toggleCard('isadjustments', !adjustments)}
                isExpanded={adjustments}
                padding={'0.8rem'}
                cursor={'pointer'}
            >
                <>
                    {adjustments &&
                    adjustmentsDetails?.length &&
                    adjustmentsDetails?.length > 0 ? (
                        <>
                            {adjustmentsDetails?.map((adjustValue) => {
                                const nonTissueProducts =
                                    adjustValue?.products &&
                                    adjustValue?.products?.length > 0
                                        ? adjustValue?.products?.filter(
                                              (x) => x.salesOrg !== 'S030'
                                          )
                                        : [];

                                const tissueProducts =
                                    adjustValue?.products &&
                                    adjustValue?.products?.length > 0
                                        ? adjustValue?.products?.filter(
                                              (x) => x.salesOrg === 'S030'
                                          )
                                        : [];

                                return (
                                    <AdjustmentContianer
                                        key={adjustValue.creditOrderNo}
                                    >
                                        {nonTissueProducts.length > 0 ? (
                                            <AdjustmentContentWrapper>
                                                <AdjustmentContainer
                                                    headerTitle={
                                                        countryISOCode === 'US'
                                                            ? t('orders.orderTypes.nonTissue')
                                                            : t('orders.shipTrackLabels.productItemDescriptionLabel')
                                                    }
                                                    adjustment={{
                                                        ...adjustValue,
                                                    }}
                                                    handleSetItemClick={
                                                        handleSetItemClick
                                                    }
                                                    ordersList={ordersList}
                                                    products={nonTissueProducts}
                                                />
                                            </AdjustmentContentWrapper>
                                        ) : null}

                                        {tissueProducts.length > 0 ? (
                                            <AdjustmentContentWrapper>
                                                <AdjustmentContainer
                                                    headerTitle={t('consignment.productType.type.tissue')}
                                                    adjustment={{
                                                        ...adjustValue,
                                                    }}
                                                    handleSetItemClick={
                                                        handleSetItemClick
                                                    }
                                                    ordersList={ordersList}
                                                    products={tissueProducts}
                                                />
                                            </AdjustmentContentWrapper>
                                        ) : null}
                                    </AdjustmentContianer>
                                );
                            })}
                            {adjustmentSummary?.debitAdjustmentTotal ||
                                adjustmentSummary?.creditAdjustmentTotal ||
                                (adjustmentSummary?.adjustmentTotal && (
                                    <AdjustmentContianer>
                                        <Card
                                            margin={'0 0 10px 0'}
                                            padding={'10px'}
                                        >
                                            <AdjustmentSummary
                                                margin={'0 0 10px 0'}
                                            >
                                                <AdjustmentSummaryDataContiner>
                                                    <AdjustmentSummaryFont
                                                        grossAmount
                                                    >
                                                        {t('orders.index.subtotal')}
                                                    </AdjustmentSummaryFont>
                                                </AdjustmentSummaryDataContiner>
                                                <AdjustmentSummaryDataContiner
                                                    justifyContent={'flex-end'}
                                                >
                                                    <AdjustmentSummaryFont
                                                        grossAmount
                                                    ></AdjustmentSummaryFont>
                                                </AdjustmentSummaryDataContiner>
                                            </AdjustmentSummary>
                                            {adjustmentSummary &&
                                            adjustmentSummary?.debitAdjustmentTotal !==
                                                undefined &&
                                            adjustmentSummary?.debitAdjustmentTotal !==
                                                null ? (
                                                <AdjustmentSummary
                                                    margin={'0 0 5px 0'}
                                                >
                                                    <AdjustmentSummaryDataContiner>
                                                        <AdjustmentSummaryFont>
                                                            {t('orders.index.debits')}
                                                        </AdjustmentSummaryFont>
                                                    </AdjustmentSummaryDataContiner>
                                                    <AdjustmentSummaryDataContiner
                                                        justifyContent={
                                                            'flex-end'
                                                        }
                                                    >
                                                        <AdjustmentSummaryFont>
                                                            {setCurrencyFormat(
                                                                adjustmentSummary.debitAdjustmentTotal,
                                                                true,
                                                                {
                                                                    currency:
                                                                        currencyISOCode,
                                                                }
                                                            )}
                                                        </AdjustmentSummaryFont>
                                                    </AdjustmentSummaryDataContiner>
                                                </AdjustmentSummary>
                                            ) : null}
                                            {adjustmentSummary &&
                                            adjustmentSummary?.creditAdjustmentTotal !==
                                                undefined &&
                                            adjustmentSummary?.creditAdjustmentTotal !==
                                                null ? (
                                                <AdjustmentSummary
                                                    margin={'0 0 5px 0'}
                                                >
                                                    <AdjustmentSummaryDataContiner>
                                                        <AdjustmentSummaryFont>
                                                            {t('orders.orderTypes.credit')}
                                                        </AdjustmentSummaryFont>
                                                    </AdjustmentSummaryDataContiner>
                                                    <AdjustmentSummaryDataContiner
                                                        justifyContent={
                                                            'flex-end'
                                                        }
                                                    >
                                                        <AdjustmentSummaryFont>
                                                            {setCurrencyFormat(
                                                                adjustmentSummary.creditAdjustmentTotal,
                                                                true,
                                                                {
                                                                    currency:
                                                                        currencyISOCode,
                                                                }
                                                            )}
                                                        </AdjustmentSummaryFont>
                                                    </AdjustmentSummaryDataContiner>
                                                </AdjustmentSummary>
                                            ) : null}
                                            {adjustmentSummary &&
                                            adjustmentSummary?.adjustmentTotal !==
                                                undefined &&
                                            adjustmentSummary?.adjustmentTotal !==
                                                null ? (
                                                <AdjustmentSummary
                                                    margin={'0 0 10px 0'}
                                                >
                                                    <AdjustmentSummaryDataContiner>
                                                        <AdjustmentSummaryFont
                                                            grossAmount
                                                        >
                                                            {t('orders.orderDetails.priceOverride.priceOverrideSummary.total')}
                                                        </AdjustmentSummaryFont>
                                                    </AdjustmentSummaryDataContiner>
                                                    <AdjustmentSummaryDataContiner
                                                        justifyContent={
                                                            'flex-end'
                                                        }
                                                    >
                                                        <AdjustmentSummaryFont
                                                            grossAmount
                                                        >
                                                            {setCurrencyFormat(
                                                                adjustmentSummary.adjustmentTotal,
                                                                true,
                                                                {
                                                                    currency:
                                                                        currencyISOCode,
                                                                }
                                                            )}
                                                        </AdjustmentSummaryFont>
                                                    </AdjustmentSummaryDataContiner>
                                                </AdjustmentSummary>
                                            ) : null}
                                        </Card>
                                        <RequestInvoiceContainer
                                            margin={'0 0 0 0'}
                                        >
                                            <DesktopInvoiceButtonContainer>
                                                <UsagePriceFont
                                                id="orders-adjustments-request-invoice-link"
                                                    color={'#1010EB'}
                                                    fontFamily={
                                                        'AvenirNextWorld Demi'
                                                    }
                                                    fontSize={'14px'}
                                                    onClick={
                                                        requestInvoiceHandler
                                                    }
                                                    cursor={'pointer'}
                                                    opacity={
                                                        !isRequestInvoice &&
                                                        '0.3'
                                                    }
                                                >
                                                    {t('orders.reportsAndInvoice.requestInvoice.requestInvoiceButton')}
                                                </UsagePriceFont>
                                            </DesktopInvoiceButtonContainer>
                                            <MobileInvoiceButtonConainer>
                                                <Button
                                                    id={'orders-orderdetails-adjustments-requestinvoicebutton'}
                                                    show
                                                    //primary={isRequestInvoice}
                                                    clicked={
                                                        requestInvoiceHandler
                                                    }
                                                    width={'100%'}
                                                    height={'2.4rem'}
                                                    padding={'0'}
                                                    fontSize={'14px'}
                                                    //disabled={!isRequestInvoice}
                                                    variant={isRequestInvoice ? ButtonStyles?.primary : ButtonStyles?.disabled}
                                                >
                                                    {t('orders.reportsAndInvoice.requestInvoice.requestInvoiceButton')}
                                                </Button>
                                            </MobileInvoiceButtonConainer>
                                        </RequestInvoiceContainer>
                                    </AdjustmentContianer>
                                ))}
                        </>
                    ) : null}
                </>
            </CollapsableCard>
        </>
    );
};

export default Adjustments;
